import { createContext, useContext } from "react"

// =============================================================================
// Context
// =============================================================================

export type TabLinksContextValue = {
  currentPath: string
}

export const TabLinksContext = createContext<TabLinksContextValue | null>(null)

export function useTabLinksContext(): TabLinksContextValue {
  const context = useContext(TabLinksContext)
  if (!context) throw new Error("TabLinks.Item must be used within a TabLinks")
  return context
}
